import { render, staticRenderFns } from "./rightContent.vue?vue&type=template&id=611b70e8&"
import script from "./rightContent.vue?vue&type=script&lang=js&"
export * from "./rightContent.vue?vue&type=script&lang=js&"
import style0 from "./rightContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports